module.exports = __webpack_public_path__ + "img/b_Forsmax_2.7e5d7046.jpeg";